import { render, staticRenderFns } from "./serveProjectClassify.vue?vue&type=template&id=46696c22&scoped=true&"
import script from "./serveProjectClassify.vue?vue&type=script&lang=js&"
export * from "./serveProjectClassify.vue?vue&type=script&lang=js&"
import style0 from "./serveProjectClassify.vue?vue&type=style&index=0&id=46696c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46696c22",
  null
  
)

export default component.exports